import api from '@js/actions/api';

export const addFavorite = (rideId) => (
    api.post(`/api/v1/rides/${rideId}/favorite`)
);

export const removeFavorite = (rideId) => (
    api.delete(`/api/v1/rides/${rideId}/favorite`)
);

export const fetchFavoriteIds = (requestOptions = {}) => (
    api.get('/api/v1/favorites/ids', {}, {
        priorityLow: true,
        ...requestOptions
    })
);
